export default "__VITE_ASSET__Ck7HyQY3__"